import { z } from 'zod';

export const zodErrorMap: z.ZodErrorMap = (issue, ctx) => {
  switch (issue.code) {
    case z.ZodIssueCode.invalid_type:
      if (issue.received === 'undefined' || issue.received === 'null') {
        return { message: 'Campo obrigatório' };
      }
      return { message: 'Tipo de dado inválido' };

    case z.ZodIssueCode.too_small:
      if (issue.type === 'string') {
        return { message: issue.minimum === 1 ? 'Campo obrigatório' : `Mínimo de ${issue.minimum} caracteres` };
      }
      return { message: `Valor abaixo do mínimo permitido (${issue.minimum})` };

    case z.ZodIssueCode.too_big:
      if (issue.type === 'string') {
        return { message: `Máximo de ${issue.maximum} caracteres` };
      }
      return { message: `Valor acima do máximo permitido (${issue.maximum})` };

    case z.ZodIssueCode.invalid_string:
      if (issue.validation === 'email') return { message: 'E-mail inválido' };
      if (issue.validation === 'url') return { message: 'URL inválida' };
      return { message: 'Formato de texto inválido' };

    case z.ZodIssueCode.invalid_enum_value:
      return { message: 'Opção inválida' };

    case z.ZodIssueCode.invalid_date:
      return { message: 'Data inválida' };

    case z.ZodIssueCode.not_finite:
      return { message: 'O valor deve ser um número finito' };

    case z.ZodIssueCode.custom:
      return { message: ctx.defaultError };

    default:
      return { message: ctx.defaultError };
  }
};
